import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import Footer from "../Footer/Footer";
import add from "../../Assets/Icon material-add.png";
import mapMarker from "../../Assets/icon-map-marke.png";
import "./Center.css";
import LpForm from "../../Pages/packageDetailsPage/LpForm";
import Sambanner from "../../Assets/newAsset/imaging/sam.webp";
import { useDispatch, useSelector } from "react-redux";
import { IoIosPin, IoMdMail, IoIosArrowDown } from "react-icons/io";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import { FaPhoneAlt } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import SimpleForm from "../chatbot/SimpleForm";
import { Scroll } from "../Scroll function/scroll";
import Loader from "../Loader/Loader";
import { GrMapLocation } from "react-icons/gr";
import OutsideAlerter from "../CustomHooks/OutClickNew";
import {
  centerAction,
  centerCollectionAction,
  paginationAction,
  labPagination,
  getCity,
  setCity,
  getCurrentLocation,
} from "../../Redux/Actions";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const MapWithAMarker = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap defaultZoom={8} defaultCenter={{ lat: 28.5355, lng: 77.391 }}>
      <Marker position={{ lat: latitude, lng: longitude }} />
    </GoogleMap>
  ))
);

//HANDEL CITY & LAB
const selectvalue = (e) => {
  setvalue(e.target.value);
};
const arrayData = [1, 2, 3, 4];

function Center() {
  const [latitude, setLatitude] = useState(28.5355);
  const [longitude, setLongitude] = useState(77.391);

  const MapWithAMarker = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap defaultZoom={8} defaultCenter={{ lat: 28.5355, lng: 77.391 }}>
        <Marker position={{ lat: latitude, lng: longitude }} />
      </GoogleMap>
    ))
  );

  const [value, setvalue] = useState("Lab");
  const [cityName, setCity] = useState("");
  const [labname, setlabName] = useState("");
  const [all, setAll] = useState("");
  const dispatch = useDispatch();
  ///const items
  const [items, setItems] = useState([]);
  const addressData = useSelector((state) => state.centerAdress);
  const collectionData = useSelector((state) => state.collectionCenter);
  const paginatedDataStore = useSelector((state) => state.paginationReducer);

  const labPaginationStore = useSelector((state) => state.labpaginationReducer);

  useEffect(() => {
    dispatch(centerAction(cityName, labname));
  }, [value, cityName, labname]);

  const { loading, center } = addressData;
  const { loading: collectionLoading } = collectionData;
  const { loading: paginationLoading } = paginatedDataStore;
  const { loading: labpaginationLoading } = labPaginationStore;
  const [paginatedData, setPaginated] = useState("");
  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [display, setDisplay] = useState(false);
  const [searchCity, setSearchCity] = useState("");

  const [Labpagination, setLabpagination] = useState("");
  //get collection center data
  useEffect(() => {
    // console.log("value data", value, cityName);

    dispatch(centerCollectionAction(cityName, labname));
  }, [value, cityName, labname]);

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: cityLoading } = navCity;

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const token = userDetails && userDetails.token;
    dispatch(getCity());
  }, []);

  useEffect(() => {
    if (!collectionData.loading) {
      // console.log("store data", collectionData);
      setPaginated(collectionData.collection);
    } else {
      // console.log("store data", collectionData.collection);
    }
  }, [collectionData, cityName]);

  console.log(Labpagination);

  useEffect(() => {
    if (addressData.loading) {
    } else {
      setLabpagination(addressData?.center);
    }
  }, [addressData.loading, cityName, Labpagination]);

  const handelCity2 = (e) => {
    if (e.target.value == "Select City") {
      setCity("");
      console.log("inside select City--->", e.target.value);
    } else {
      setCity(e.target.value);
      console.log("inside", cityName);
    }
    console.log("inside", cityName);

    setSearchCity(e.target.value?.replace(" ", "_"));
    setDisplay(true);
  };

  const handelCity = (city) => {
    console.log(city, "<<<<");
    const userProfile = JSON.parse(localStorage.getItem("user"));
    localStorage.setItem("city", city);
    setSearchCity(city);
    setCity(city != "" ? city : "");
    setDisplay(false);

    // if(city.target.value=="Select City"){
    //       // setCity("");
    //       console.log("inside select City--->",city);
    //     }
  };

  console.log("---------------------------------outside", cityName);
  //   const [labName, setLabName] = useState("");
  const handelLabName = (e) => {
    // setLabName(e.target.value);
    // if(cityName || cityName==""){
    setlabName(e.target.value);
    // setCity("");
    // }

    // console.log(cityName);
  };
  //console.log("pagination data", paginatedData);
  //
  const selectonMap = (datafromClick) => {
    // console.log("clicked aftr data", datafromClick);
    setLatitude(parseInt(datafromClick.latitude));
    setLongitude(parseInt(datafromClick.longitude));
  };

  //handel lab data pagination
  const handelLabclick = (data) => {
    Scroll();
    let cuurrLabpage = data.selected + 1;
    dispatch(labPagination(cuurrLabpage));
  };

  useEffect(() => {
    if (!labpaginationLoading) {
      setLabpagination(labPaginationStore.paginated);
      // console.log("lab pagination data", labPaginationStore.paginated);
    }
  }, [labpaginationLoading, cityName, Labpagination]);
  //handel center data pagination
  const handlePageClick = (data) => {
    Scroll();
    let cuurrpage = data.selected + 1;
    dispatch(paginationAction(cuurrpage));
  };
  useEffect(() => {
    if (!paginationLoading) {
      setPaginated(paginatedDataStore.paginated);
    }
  }, [paginationLoading, cityName]);

  const [select, setSelect] = useState(false);

  const buttonHandler = (e) => {
    setvalue(e.target.value);
    setSelect(false);
  };

  const buttonHandler2 = (e) => {
    setvalue(e.target.value);
    setSelect(true);
  };

  console.log("Labpagination-----------------", labname);

  const [width, setWidth] = useState("");

  useEffect(() => {
    function updateSize() {
      if (typeof window !== "undefined") {
        setWidth(window.screen.width);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  console.log(width);

  const [FilterCheck, setFilterCheck] = useState(false);

  const FilterHandler = () => {
    setFilterCheck(!FilterCheck);
  };

  // console.log(searchCity,"city ===>>>>>")

  return (
    <>
      <Helmet>
        <title>
          Our Labs & Network: Affordable Test Available across 250+ Cities with
          100% Accurate Reports.
        </title>
        <meta
          name="description"
          content="Redcliffe Labs are spread across Delhi - NCR and more than 250+ Cities. Our network labs are guaranteed of 100% accuracy"
        />
      </Helmet>

      <NewHeader />
      <div className="CenterNew">
        <div className="center">
          <div className="center__leftSide">
            <h2 className="heading_centerPink">#RedcliffeLabs</h2>
            <h1 className="heading_centerBlue">Our Lab & Network</h1>
          </div>
          <div className="center__rightBanner">
            <img src={Sambanner} alt={Sambanner} />
          </div>
        </div>

        <div className="center__address">
          {width > 780 ? (
            <div className="center__addressLeft">
              <form>
                <div className="form_center">
                  <h4>FILTERS</h4>

                  <div className="input__divCenter">
                    <div className="displayFlex">
                      {" "}
                      <input
                        type="button"
                        className={
                          value == "Lab" ? "inputSelect" : "inputNotSelect"
                        }
                        name="Type"
                        value="Lab"
                        checked={value == "Lab"}
                        onChange={() => setvalue("Lab")}
                        onClick={buttonHandler}
                      />{" "}
                      &nbsp;
                    </div>
                    <div className="displayFlex">
                      <input
                        type="button"
                        className={
                          select === true ? "inputSelect" : "inputNotSelect"
                        }
                        name="Type"
                        checked={value == "Collection Center"}
                        onChange={() => setvalue("Collection Center")}
                        onClick={(e) => buttonHandler2(e)}
                        value="Collection Centre"
                      />{" "}
                    </div>
                  </div>

                  <div className="input__divCenterNew">
                    {/* <div className="input__divCenter"> */}
                    <label>Search By</label>
                    <div className="NewCenterCSSForSelectCity">
                      <div className="selectAreaPincode">
                        <OutsideAlerter
                          onClickOut={() => {
                            setDisplay(false);
                          }}
                        >
                          <div className="citySelectHome">
                            <form
                              onSubmit={(e) => {
                                e.preventDefault();
                              }}
                            >
                              <input
                                // style={{ width: "120px" }}
                                className="cityDrop_model"
                                value={searchCity?.replace("_", " ")}
                                onFocus={(e) => {
                                  e.target.select(), setDisplay(true);
                                }}
                                onChange={(e) => {
                                  handelCity2(e);
                                }}
                                placeholder="search city"
                              />
                            </form>
                            {display ? (
                              <div
                                className="divCity divCity2"
                                defaultValue="Noida"
                              >
                                <span
                                  onClick={() => {
                                    setDisplay(false),
                                      setSearchCity(""),
                                      handelCity("");
                                  }}
                                  // value="Select City"
                                >
                                  Select City
                                </span>
                                {navCity &&
                                navCity.navCities &&
                                navCity.navCities.cities ? (
                                  navCity.navCities.cities
                                    .filter((city, index) => {
                                      if (searchCity == "") {
                                        return city;
                                      } else if (
                                        city
                                          .toLowerCase()
                                          .includes(searchCity.toLowerCase())
                                      ) {
                                        return city;
                                      }
                                    })
                                    .map((ele, index) => {
                                      // console.log(ele.replace("_", " "), "<<<<");
                                      return (
                                        <span
                                          onClick={() => handelCity(ele)}
                                          key={index}
                                          selected={
                                            ele == citySelected.citySelect
                                          }
                                          value={ele}
                                        >
                                          {ele?.replace("_", " ")}
                                        </span>
                                      );
                                    })
                                ) : (
                                  <Loader />
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </OutsideAlerter>
                        {/* <div className="verticalLine" /> */}
                        {/* <div className="selectPincode">
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Select Address
                      </span>
                      <span>You can add from your addresses</span>
                    </div>
                    <div className="userAddress">
                      <div className="dis_flex flex-justify">
                        <label className="addressFontBold">Lokesh</label>
                        <input
                          value=""
                          type="radio"
                          style={{ width: "auto" }}
                        />
                      </div>
                      <div style={{ marginTop: "1rem" }}>
                        <p className="addrespara">
                          007, Venice Beach, Omaha Estate, 42142
                        </p>
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Or Enter Pincode
                      </span>
                      <span>Select Pincode to see checkup availability</span>
                      <div className="pincodeInput ">
                        <MdLocationPin />
                        <input placeholder="Enter Pincode" type="text" />
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="getLocation">
                      <img
                        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/3311e52a-a954-496c-b4c1-38d9cc1700dc.png"
                        width="20px"
                      />

                      <h4 onClick={getLoc} className="danger">
                        Detect from my location
                      </h4>
                    </div>
                  </div> */}
                      </div>
                    </div>

                    <input
                      type="text"
                      className="inputNotSelect"
                      placeholder="Search Name"
                      value={labname}
                      onChange={(e) => handelLabName(e)}
                    />
                    {/* </div> */}
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <>
              {/* <div> */}
              <div className="FilterMobForLabCenter">
                <div
                  className="insideFilterMobForLabCenter"
                  onClick={FilterHandler}
                >
                  <h4>FILTERS</h4>
                  <IoIosArrowDown
                    style={{
                      fontSize: "30px",
                      marginTop: "5px",
                      color: "#707070",
                    }}
                  />
                </div>
              </div>
              {FilterCheck ? (
                <div className="center__addressLeft showBar">
                  <form>
                    <div className="form_center">
                      <h4>FILTERS</h4>

                      <div className="input__divCenter">
                        <div className="displayFlex">
                          {" "}
                          <input
                            type="button"
                            className={
                              value == "Lab" ? "inputSelect" : "inputNotSelect"
                            }
                            name="Type"
                            value="Lab"
                            checked={value == "Lab"}
                            onChange={() => setvalue("Lab")}
                            onClick={buttonHandler}
                          />{" "}
                          &nbsp;
                        </div>
                        <div className="displayFlex">
                          <input
                            type="button"
                            className={
                              select === true ? "inputSelect" : "inputNotSelect"
                            }
                            name="Type"
                            checked={value == "Collection Center"}
                            onChange={() => setvalue("Collection Center")}
                            onClick={(e) => buttonHandler2(e)}
                            value="Collection Centre"
                          />{" "}
                        </div>
                      </div>

                      <div className="input__divCenterNew">
                        {/* <div className="input__divCenter"> */}
                        <label>Search By</label>
                        {/* <input 
                type="text"
                className="inputNotSelectForName"
                  placeholder="Search by city"
                  value={cityName}
                  onChange={handelCity}
                /> */}

                        <div className="NewCenterCSSForSelectCity">
                          <div className="selectAreaPincode">
                            <OutsideAlerter
                              onClickOut={() => {
                                setDisplay(false);
                              }}
                            >
                              <div className="citySelectHome">
                                <form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  <input
                                    // style={{ width: "120px" }}
                                    className="cityDrop_model"
                                    value={searchCity?.replace("_", " ")}
                                    onFocus={(e) => {
                                      e.target.select(), setDisplay(true);
                                    }}
                                    onChange={(e) => {
                                      setSearchCity(
                                        e.target.value?.replace(" ", "_")
                                      ),
                                        setDisplay(true);
                                    }}
                                    placeholder="search city"
                                  />
                                </form>
                                {display ? (
                                  <div
                                    className="divCity divCity2"
                                    defaultValue="Noida"
                                  >
                                    <span
                                      onClick={(e) => {
                                        setDisplay(false),
                                          setSearchCity(""),
                                          handelCity("");
                                      }}
                                      // value=" "
                                    >
                                      Select City
                                    </span>
                                    {navCity &&
                                    navCity.navCities &&
                                    navCity.navCities.cities ? (
                                      navCity.navCities.cities
                                        .filter((city, index) => {
                                          if (searchCity == "") {
                                            return city;
                                          } else if (
                                            city
                                              .toLowerCase()
                                              .includes(
                                                searchCity.toLowerCase()
                                              )
                                          ) {
                                            return city;
                                          }
                                        })
                                        .map((ele, index) => {
                                          // console.log(ele.replace("_", " "), "<<<<");
                                          return (
                                            <span
                                              onClick={() => handelCity(ele)}
                                              key={index}
                                              selected={
                                                ele == citySelected.citySelect
                                              }
                                              value={ele}
                                            >
                                              {ele?.replace("_", " ")}
                                            </span>
                                          );
                                        })
                                    ) : (
                                      <Loader />
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            </OutsideAlerter>
                            {/* <div className="verticalLine" /> */}
                            {/* <div className="selectPincode">
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Select Address
                      </span>
                      <span>You can add from your addresses</span>
                    </div>
                    <div className="userAddress">
                      <div className="dis_flex flex-justify">
                        <label className="addressFontBold">Lokesh</label>
                        <input
                          value=""
                          type="radio"
                          style={{ width: "auto" }}
                        />
                      </div>
                      <div style={{ marginTop: "1rem" }}>
                        <p className="addrespara">
                          007, Venice Beach, Omaha Estate, 42142
                        </p>
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="disFlex_column flex-justify">
                      <span className="selectAddress addressFontBold ">
                        Or Enter Pincode
                      </span>
                      <span>Select Pincode to see checkup availability</span>
                      <div className="pincodeInput ">
                        <MdLocationPin />
                        <input placeholder="Enter Pincode" type="text" />
                      </div>
                    </div>
                    <div className="border_horizontal" />
                    <div className="getLocation">
                      <img
                        src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/3311e52a-a954-496c-b4c1-38d9cc1700dc.png"
                        width="20px"
                      />

                      <h4 onClick={getLoc} className="danger">
                        Detect from my location
                      </h4>
                    </div>
                  </div> */}
                          </div>
                        </div>

                        <input
                          type="text"
                          className="inputNotSelect"
                          placeholder="Search Name"
                          value={labname}
                          onChange={(e) => handelLabName(e)}
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </form>
                </div>
              ) : null}
              {/* </div> */}
            </>
          )}

          <div className="center__addressRight">
            {loading && collectionLoading ? (
              <Loader />
            ) : value == "Lab" && Labpagination !== "" ? (
              <div>
                {
                  //  setLatitude(addressData.center[0].)
                  // setDimension();
                  // setLatitude(addressData.center[0].lab_credentials.latitude),
                  // setLongitude(addressData.center[0].lab_credentials.longitude)
                }
                <h4 className="packDetails_center">
                  Found <span className="colorPink">{Labpagination.count}</span>{" "}
                  results {cityName ? "In " : null}
                  {cityName ? (
                    <span
                      className="colorPink"
                      style={{ textTransform: "capitalize" }}
                    >
                      {cityName}
                    </span>
                  ) : (
                    ""
                  )}
                  {/* <span
                  className="colorPink"
                  style={{ textTransform: "capitalize" }}
                >
                  {cityName}
                </span>{" "} */}
                </h4>

                {Labpagination == "" ? (
                  <Loader />
                ) : (
                  Labpagination.results.map((val) => (
                    <div
                      key={val.lab_credentials.id}
                      className="address_card"
                      onClick={() => selectonMap(val.lab_credentials)}
                    >
                      {val.lab_credentials.image.length > 0 ? (
                        <div className="places_piks">
                          {/* {val.lab_credentials.image?.map((values, index) => {
                          return (
                            <> */}
                          {/* <img
                                src={values.file}
                                alt={values.file}
                                key={index}
                              /> */}
                          {/* </>
                          );
                        })} */}
                          <img src={Sambanner} alt="sameerbanner" />
                          <img src={Sambanner} alt="sameerbanner" />
                          <img src={Sambanner} alt="sameerbanner" />
                          <img src={Sambanner} alt="sameerbanner" />
                          {/* <img src={Sambanner} alt="sameerbanner" /> */}
                        </div>
                      ) : null}

                      <div className="place_address">
                        {val.lab_credentials?.latitude == null &&
                        val.lab_credentials?.longitude == null ? null : (
                          <div className="topPinLogoDiv">
                            <a
                              href={`http://maps.google.com/maps?z=12&t=m&q=loc:${val.lab_credentials?.latitude}+${val.lab_credentials?.longitude}`}
                              target="_blank"
                              style={{ color: "gray" }}
                            >
                              <span className="linkAnchor">
                                {/* <GrMapLocation />  */}
                                <img src={mapMarker} alt="mapMarker" />
                                Open in Google Maps
                              </span>
                            </a>
                          </div>
                        )}

                        <div className="destiantion_details">
                          <span className="Main_Address">
                            Redcliffe {val.lab_credentials.name} Lab
                          </span>
                          <div className="detailsSpanMain">
                            <span className="detailsSpan">
                              <img src={add} alt="add" />{" "}
                              <span>{val.lab_credentials?.lab_address}</span>
                            </span>

                            <span className="detailsSpan">
                              <FaPhoneAlt /> <span> 898 898 8787</span>
                            </span>
                            <span className="detailsSpan">
                              <IoMdMail />
                              <span> care@redcliffelabs.com</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}

                {Labpagination.count > 30 ? (
                  <ReactPaginate
                    previousLabel={"<"}
                    breakLabel="..."
                    nextLabel={">"}
                    onPageChange={handelLabclick}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(
                      Labpagination.count / Labpagination.page_size
                    )}
                    renderOnZeroPageCount={null}
                    activeClassName={"pageActive"}
                    containerClassName={"paginationList"}
                    pageClassName={"paginationList"}
                    pageLinkClassName={"pagelinkTag"}
                    nextLabelClass={"previous"}
                    previousClassName={"previousClass"}
                    nextClassName={"previousClass"}
                  />
                ) : null}

                {/* {loading ? (
                "loading"
              ) : (
                <MapWithAMarker
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBPjDlsHYhWtjt3FxgRPnTMXN-qJZ9hz0s&libraries=places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
              )} */}
              </div>
            ) : collectionLoading ? (
              <Loader />
            ) : (
              <div>
                <h4 className="packDetails_center">
                  Found <span className="colorPink">{paginatedData.count}</span>{" "}
                  results {cityName ? "In " : null}
                  <span
                    className="colorPink"
                    style={{ textTransform: "capitalize" }}
                  >
                    {cityName}
                  </span>{" "}
                  {/* {console.log(
                  "collection center",
                  collectionLoading,
                  collectionData.collection.results
                )} */}
                </h4>
                {paginatedData !== ""
                  ? paginatedData.results.map((collection) => (
                      <div key={collection.id} className="address_card">
                        {collection?.images && collection?.images?.length > 0 ? (
                          <div className="places_piks">
                            {collection?.images.map((val) =>
                              console.log("console imgaes", val)
                            )}
                            {/* {collection?.images.map((values, index) => {
                            return ( */}
                            <>
                              <img src={Sambanner} alt="sameerbanner" />
                              <img src={Sambanner} alt="sameerbanner" />
                              <img src={Sambanner} alt="sameerbanner" />
                              <img src={Sambanner} alt="sameerbanner" />
                            </>
                            {/* );
                          })} */}
                          </div>
                        ) : null}

                        <div className="place_address">
                          {collection.latitude == null &&
                          collection.logitude == null ? null : (
                            <div className="topPinLogoDiv">
                              <a
                                href={`http://maps.google.com/maps?z=12&t=m&q=loc:${collection.latitude}+${collection.logitude}`}
                                target="_blank"
                                style={{ color: "#FF9100" }}
                              >
                                <span className="linkAnchor">
                                  <GrMapLocation /> Open in Google Maps
                                </span>
                              </a>
                            </div>
                          )}

                          <div className="destiantion_details">
                            <span className="Main_Address">
                              {collection.name} Redcliffe Authorized Collection
                              Centre
                            </span>

                            <span className="detailsSpan">
                              {/* <IoIosPin /> */}
                              <img src={add} alt="add" />
                              <div className="centerData">
                                {collection.address}
                              </div>
                            </span>

                            {/* <span className="detailsSpan">
                        <FaPhoneAlt />
                        <div className="centerData">
                          {collection.mobile
                            ? collection.mobile
                            : "898 898 8787"}
                        </div>
                      </span> */}
                            {/* <span className="detailsSpan">
                        <IoMdMail />
                        <div className="centerData">
                          {collection.email
                            ? collection.email
                            : "care@redcliffelabs.com"}
                        </div>
                      </span> */}
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
                {paginatedData.count > 30 ? (
                  <ReactPaginate
                    previousLabel={"<"}
                    nextLabel={">"}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(
                      paginatedData.count / paginatedData.page_size
                    )}
                    renderOnZeroPageCount={null}
                    activeClassName={"pageActive"}
                    containerClassName={"paginationList"}
                    pageClassName={"paginationList"}
                    pageLinkClassName={"pagelinkTag"}
                    nextLabelClass={"previous"}
                    previousClassName={"previousClass"}
                    nextClassName={"previousClass"}
                  />
                ) : null}

                {/* {collectionLoading ? (
                "loading"
              ) : (
                <MapWithAMarker
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBPjDlsHYhWtjt3FxgRPnTMXN-qJZ9hz0s&libraries=places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
              )} */}
              </div>
            )}
            {/* {loading ? (
            "loading"
          ) : (
            <div>
              <h4 className="packDetails_center">
                Found <span className="colorPink">3</span> results in{" "}
                <span className="colorPink">Delhi</span>{" "}
              </h4>
              {addressData &&
                addressData?.center ?
                addressData?.center?.map((val, index) => {
                  return (
                    <div key={val.id} className="address_card">
                      <div className="places_piks">
                        {val.lab_credentials?.img.map((val, index) => {
                          return (
                            <>
                              <img src={val} alt={val} />
                            </>
                          );
                        })}
                      </div>
                      <div className="place_address">
                        <div className="topPinLogoDiv">
                          <span>
                            <GrMapLocation /> Open in Google Maps
                          </span>
                        </div>
                        <div className="destiantion_details">
                          <span className="Main_Address">
                            {val.lab_credentials.name}
                          </span>

                          <span className="detailsSpan">
                            <IoIosPin /> {val.lab_credentials.lab_address}
                          </span>

                          <span className="detailsSpan">
                            <FaPhoneAlt /> {val.lab_credentials?.phone_number}
                          </span>
                          <span className="detailsSpan">
                            <IoMdMail />
                            {val.lab_credentials?.email}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                }) : null}

              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14008.493983013297!2d77.3668853!3d28.6260606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1636374584127!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: 0 }}
                loading="lazy"
              ></iframe>
            </div>
          )} */}
          </div>
        </div>
      </div>
      <div className="chatbot">
        <SimpleForm />
      </div>
      {/* <ScrolltoTop /> */}

      <Footer />
    </>
  );
}

export default {
  component: Center,
};